import {Page} from 'utils/page-utils';
import ReservationAPI from 'api/reservation';
import {initialState} from 'store/parking-pass/parking-pass-reducer';
import ReservationUtils from 'utils/reservation-utils';

const getInitialState = async ({
    state,
    params,
    route: {
        location: {search},
    },
}) => {
    const urlParams = new URLSearchParams(search);
    const reservationId = params?.id;
    const accessKey = urlParams.get('key');
    const parkingPassSlice = initialState();

    if (!reservationId) {
        parkingPassSlice.error =
            ReservationUtils.POST_PURCHASE_ERRORS_ENUM.NO_ID;
    } else if (!accessKey) {
        parkingPassSlice.error =
            ReservationUtils.POST_PURCHASE_ERRORS_ENUM.NO_ACCESS_KEY;
    } else {
        try {
            parkingPassSlice.data = await ReservationAPI.getById({
                reservationId,
                accessKey,
            });
        } catch (error) {
            parkingPassSlice.error = ReservationUtils.getErrorTypeFromServerError(
                error
            );
        }
    }

    // add accessKey to store
    parkingPassSlice.accessKey = accessKey;

    state.searchRequest.pageType = Page.PARKING_PASS;

    return {
        ...state,
        parkingPass: parkingPassSlice,
    };
};

export default getInitialState;
